// extracted by mini-css-extract-plugin
module.exports = {"recommend":"recommend_recommend__5681K"};